var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6802 72.125C88.7431 68 86.4185 62.75 83.7064 57.875C80.9947 52.625 78.2827 47.75 75.9581 43.25C71.3089 35 63.9477 24.5 58.5235 17C56.5864 14.375 53.4868 12.5 50.0002 12.5C46.5135 12.5 43.4139 14 41.4767 17C36.0527 24.5 29.079 35 24.0424 43.25C19.0058 51.875 13.1943 63.875 9.32004 72.125C7.77033 75.125 8.15775 78.875 9.7075 81.5C11.6446 84.5 14.7441 86 18.2309 86.375C27.5292 86.75 40.3144 87.5 50.0002 87.5C59.686 87.5 72.8585 86.75 81.7693 86.375C85.2564 86.375 88.3556 84.5 90.2927 81.5C91.8427 78.875 92.2302 75.125 90.6802 72.125ZM46.9006 43.625C46.9006 42.125 48.0631 40.625 50.0002 40.625C51.9372 40.625 53.0998 41.75 53.0998 43.625V58.625C53.0998 60.125 51.9372 61.625 50.0002 61.625C48.0631 61.625 46.9006 60.5 46.9006 58.625V43.625ZM50.0002 73.625C48.0631 73.625 46.126 71.75 46.126 69.875C46.126 68 48.0631 66.125 50.0002 66.125C51.9372 66.125 53.8743 68 53.8743 69.875C53.8743 71.75 51.9372 73.625 50.0002 73.625Z",
    fill: "#FC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionTriangle);
export default __webpack_public_path__ + "static/media/attention-triangle.c00660adf8eb6ad5d24d9d8d6e73d732.svg";
export { ForwardRef as ReactComponent };